export default "__VITE_ASSET__07151f3a__"